__turbopack_context__.v({
  "card": "ZooMcW_card" + " " + __turbopack_context__.i(917291)["lbRadialStroke"] + " " + __turbopack_context__.i(917291)["lbCardBlur"],
  "iconSlot": "ZooMcW_iconSlot",
  "leaderBadge": "ZooMcW_leaderBadge" + " " + __turbopack_context__.i(917291)["monoUppercase"] + " " + __turbopack_context__.i(917291)["lbRadialStroke"] + " " + __turbopack_context__.i(917291)["lbStrokeFrosted"],
  "left": "ZooMcW_left",
  "name": "ZooMcW_name" + " " + __turbopack_context__.i(917291)["monoUppercase"],
  "nameGroup": "ZooMcW_nameGroup",
  "nameLine": "ZooMcW_nameLine",
  "nameTagSuffix": "ZooMcW_nameTagSuffix" + " " + __turbopack_context__.i(917291)["monoUppercase"],
  "rank": "ZooMcW_rank" + " " + __turbopack_context__.i(917291)["geistMonoNumbers"],
  "score": "ZooMcW_score" + " " + __turbopack_context__.i(917291)["geistMonoNumbers"],
  "scoreGroup": "ZooMcW_scoreGroup",
  "tagSeparator": "ZooMcW_tagSeparator" + " " + __turbopack_context__.i(917291)["monoUppercase"],
});
